import { render, staticRenderFns } from "./DashboardEventList.vue?vue&type=template&id=b3cbc010&scoped=true&"
import script from "./DashboardEventList.vue?vue&type=script&lang=js&"
export * from "./DashboardEventList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEventList.vue?vue&type=style&index=0&id=b3cbc010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cbc010",
  null
  
)

component.options.__file = "DashboardEventList.vue"
export default component.exports